import { TAppState } from '../../types/appState';
import { TAvailableActions } from '../../types/availableActions';
import { TOpenedChat } from '../../types/openedChats';
import { IUserInChatListSchema } from '../../types/userData';

export type TCurrentOpenedChat = TOpenedChat & {
  blocked?: boolean;
  availableActions?: TAvailableActions[] | null;
  users: IUserInChatListSchema[];
  botId?: number | null;
  isStarred?: boolean;
};

export function currentOpenChatSelector(state: TAppState): TCurrentOpenedChat | null {
  const { chatList, chatWindow, openedChats } = state;

  const currentOpenedChatId =
    chatWindow.currentOpenedChatId || chatList.removedFromSpamChatId || chatList.removedFromArchiveChatId;

  const currentChat = currentOpenedChatId !== undefined && openedChats[currentOpenedChatId];

  const currentChatListItem = chatList.chats.find(chat => chat.chatId === currentOpenedChatId);

  const blocked = currentChatListItem ? currentChatListItem.status === 'blocked' : undefined;
  const availableActions = currentChatListItem ? currentChatListItem.availableActions : null;
  const users = currentChatListItem ? currentChatListItem.users : [];
  const botId = currentChatListItem ? currentChatListItem.botId : undefined;
  const isStarred = currentChatListItem ? currentChatListItem.isStarred : undefined;

  return currentChat ? { ...currentChat, blocked, availableActions, users, botId, isStarred } : null;
}
